import { Archive, ArchiveRestore } from 'lucide-react';
import RowActionButton from '../row-action-button/row-action-button';

export interface ArchiveRowActionProps {
  isArchived: boolean;
  onClick: () => void;
}

const ArchiveRowAction = ({ isArchived, onClick }: ArchiveRowActionProps) => (
  <RowActionButton label={isArchived ? 'Wiederherstellen' : 'Archivieren'} onClick={onClick}>
    {isArchived ? <ArchiveRestore className="h-4 w-4" /> : <Archive className="h-4 w-4" />}
  </RowActionButton>
);

export default ArchiveRowAction;
